import styled from 'styled-components'
import { Skeleton } from '~/components/shared'

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: fit-content;
  margin-bottom: 1.5rem;
  display: inline-block;
`
export const Table = styled.table`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.colord9d9d9};
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-spacing: 0;
  border-collapse: separate;
`
export const Tbody = styled.tbody`
  tr:nth-child(odd) {
    background-color: ${props => props.theme.colors.colorf3f5f9};
  }

  tr:first-child td:first-child {
    border-top-left-radius: 4px;
    border-top: 1px solid ${({ theme }) => theme.colors.colord9d9d9};
    border-left: 1px solid ${({ theme }) => theme.colors.colord9d9d9};
  }
  tr:first-child td:last-child {
    border-top-right-radius: 4px;
    border-top: 1px solid ${({ theme }) => theme.colors.colord9d9d9};
    border-right: 1px solid ${({ theme }) => theme.colors.colord9d9d9};
  }
  tr:first-child td {
    border-top: 1px solid ${({ theme }) => theme.colors.colord9d9d9};
  }

  tr:last-child td:first-child {
    border-left: 1px solid ${({ theme }) => theme.colors.colord9d9d9};
    border-bottom-left-radius: 4px;
  }
  tr:last-child td:last-child {
    border-right: 1px solid ${({ theme }) => theme.colors.colord9d9d9};
    border-bottom-right-radius: 4px;
  }
  tr td:first-child {
    border-left: 1px solid ${({ theme }) => theme.colors.colord9d9d9};
  }
  tr td:last-child {
    border-right: 1px solid ${({ theme }) => theme.colors.colord9d9d9};
  }
`
export const Divider = styled.hr`
  border-top: 0px solid ${props => props.theme.colors.colorDCE3ED};
`
export const ContainerTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  > svg {
    fill: ${props => props.theme.colors.color2d3139};
    margin-right: 8px;
  }
`
export const Title = styled.h3`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  margin-left: 5px;
  color: ${props => props.theme.colors.color2d3139};
`
export const LoaderComponent = styled.div`
  position: relative;
  height: 150px;

  display: flex;
  justify-content: center;
  align-items: center;

  border: 1px solid ${props => props.theme.colors.colorDCE3ED};
  border-radius: 4px;
  margin: 24px;
  margin-bottom: 30px;
`
export const Td = styled.td`
  font-family: 'Inter';
  padding: 8px 16px 8px 16px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  text-align: left;
  line-height: 14px;
  color: ${props => props.theme.colors.color2d3139};
`
export const Th = styled.th`
  font-family: 'Inter';
  padding: 8px 16px 8px 16px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  text-align: left;
  padding: 8px 16px 8px 16px;
  line-height: 15px;
  color: ${props => props.theme.colors.color6b7786};
`

export const LoadingContainer = styled.div`
  width: 100%;
  margin-bottom: 40px;
`
export const SkeletonItem = styled(Skeleton).attrs(props => ({
  baseColor: props.theme.colors.colorf2f7ff
}))`
  margin-bottom: 10px;
  border-radius: 2px;
  margin-right: 8px;
`
export const SkeletonTitle = styled(Skeleton).attrs(props => ({
  baseColor: props.theme.colors.colorf2f7ff
}))`
  border-radius: 2px;
`
export const ContentInLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
